export default {
  title: 'Öffnungszeiten',
  headers: {
    edit_time: 'Zeit bearbeiten',
    create_time: 'Zeit hinzufügen',
  },
  labels: {
    select_all: 'Alles auswählen',
    timezone: 'Zeitzone',
  },
  fields: {
    selected_days: {
      label: 'Ausgewählte Tage',
    },
    opening_time: {
      label: 'Öffnungszeit',
    },
    closing_time: {
      label: 'Schließzeit',
    },
  },
  columns: {
    days: 'Tage',
    time: 'Uhrzeit',
  },
  buttons: {
    add_opening_time: 'Öffnungszeit hinzufügen',
    add: 'Hinzufügen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    close: 'Schließen',
    delete: 'Löschen',
    sync_from_online_shop: 'Synchronisieren aus dem Online-Shop',
  },
  projects: {
    online_shop: 'Online Shop',
    reservations: 'Reservierungen',
    storefront: 'Website',
    not_set_up: '{{project}} (für diesen Standort nicht eingerichtet)',
  },
  feedback: {
    missing_info: 'Fehlende Informationen',
  },
  toasts: {
    saving_success: 'Erfolgreich gespeichert',
    saving_error: 'Fehler beim Speichern. Bitte überprüfen Sie Ihre Informationen und versuchen Sie es erneut.',
    sync_success: 'Erfolgreich synchronisiert',
    sync_error: 'Fehler beim Synchronisieren der Öffnungszeiten aus dem Online-Shop. Bitte versuchen Sie es erneut.',
    hours_required: 'Öffnungszeiten sind erforderlich. Stattdessen bestehende Öffnungszeiten bearbeiten',
    not_copied: {
      reservations: {
        not_set_up:
          'Reservierungen wurden nicht aktualisiert: Für diesen Standort sind Reservierungen noch nicht eingerichtet. Den Grund finden Sie im Tab „Reservierungen“.',
        not_matched:
          'Reservierungen wurden nicht aktualisiert: Dort gibt es die Öffnungszeit {{time}} nicht. Prüfen Sie die Öffnungszeiten im Tab „Reservierungen“.',
        failed:
          'Reservierungen konnten nicht aktualisiert werden. Nutzen Sie im Tab „Reservierungen“ die Schaltfläche „Synchronisieren aus dem Online-Shop“.',
      },
      storefront: {
        not_set_up: 'Die Website wurde nicht aktualisiert: Für diesen Standort wurde keine Website gefunden.',
        not_matched:
          'Die Website wurde nicht aktualisiert: Dort gibt es die Öffnungszeit {{time}} nicht. Prüfen Sie die Öffnungszeiten im Tab „Storefront“.',
        failed:
          'Die Website konnte nicht aktualisiert werden. Nutzen Sie im Tab „Storefront“ die Schaltfläche „Synchronisieren aus dem Online-Shop“.',
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Zeitzone',
        },
      },
      toasts: {
        error: 'Zeitzone konnte nicht aktualisiert werden',
      },
    },
  },
};
